<div id="query-selected-overview-tab-wrapper">
  <div id="code-editor">
    <hyperkit-code-editor
      [value]="rawQuery()"
      (valueChange)="rawQuery.set($event)"  
      [options]="{ language: 'json' }"
    />
  </div>

  <div id="outcome-notes">
    <hyperkit-typography variant="h5">Query Notes</hyperkit-typography>
    <hyperkit-editor
      [value]="formattedNotes()"
      (valueChange)="formattedNotes.set($event)" 
    />
  </div>
</div>
